/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowForwardUp = createReactComponent("outline", "arrow-forward-up", "IconArrowForwardUp", [["path", { "d": "M15 14l4 -4l-4 -4", "key": "svg-0" }], ["path", { "d": "M19 10h-11a4 4 0 1 0 0 8h1", "key": "svg-1" }]]);

export { IconArrowForwardUp as default };
//# sourceMappingURL=IconArrowForwardUp.mjs.map
